import { render } from "./CrStepMassResult.vue?vue&type=template&id=54fcc954"
import script from "./CrStepMassResult.vue?vue&type=script&lang=js"
export * from "./CrStepMassResult.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__